import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { LOAD_DATA } from './GraphQL/Queries';
import { Footer } from './Components/Footer';
import { Header } from './Components/Header';
import { Info } from './Components/Info';
import { Dashboard } from './Dashboard';

export function AppStructure() {
  const [date, setDate] = useState(new Date());

  const { data, loading } = useQuery(LOAD_DATA, {
    variables: { date: date.toISOString() },
    context: { fetchOptions: { method: 'GET' } },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date());
    }, 300000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='container-fluid p-0'>
      <Header />
      <Dashboard loading={loading} date={date} data={data} />
      <Info />
      <hr className='mx-5' />
      <Footer />
    </div>
  );
}
